import apiFunction from './api'
import { join } from 'utils/url'
import { uploadBigFile } from 'utils/oss'
import { getInfo } from 'utils/IDValidator'
import { hasPermissions } from 'utils/permissions'
import saasConfig from 'saasConfig/index'
import { mapGetters } from 'vuex'
import Vue from 'vue'
// 针对api调用的配置，所有需要环境判定的api参数配置，需等api异步获取成功后方可赋值
export let prototype = null
async function apiReturn () {
  let api = await apiFunction
  prototype = {
    // 私有图片获取接口
    $privateResourcesUrl: join(api.api_server, api.env.VUE_APP_PRIVATE_RESOURCES),
    // 公开图片获取接口
    $publicResourcesUrl: join(api.api_server, api.env.VUE_APP_PUBLIC_RESOURCES),
    // 私有图片获取接口
    $privateResourcesUrlDownload: join(api.api_server, api.env.VUE_APP_PRIVATE_RESOURCES_DOWNLOAD),
    $privateResourceAttachmentLink: getPrivateResourceAttachmentLink,
    // 以上两个接口还可以添加styleName参数，指定图片大小，压缩等情况
    $publicResourceAttachmentLink: getPublicResourceAttachmentLink,
    // 服务器地址api
    $apiServer: api.api_server,
    // 移动端域名地址
    $apiServerMobile: api.api_server_mobile,
    // 图片上传api
    $uploadApi: api.api_server + '/lab/api/upload',
    // 图片上传，可通过key参数指定返回数据里的字段名称
    $uploadApiKey: api.api_server + '/lab/api/upload-json',
    // 上传文件工具方法
    $upload: uploadBigFile,
    // 解析身份证，获取信息
    $getIdCardInfo: getInfo,
    $hasPermissions: hasPermissions,
    $matchComponent: saasConfig.matchComponent,
    $mapGetters: mapGetters
  }
  Object.keys(prototype).map(key => {
    Vue.prototype[key] = prototype[key]
  })
}/**
 * 针对实验室系统的Attachment数据结构获取下载链接的方法
 * @param {*} attachment

 * @returns
 */
function getPrivateResourceAttachmentLink (attachment, autoPrefix) {
  let url = prototype.$privateResourcesUrlDownload + attachment.ossUrl.replace(/\+/g, '%2B')
  if (attachment.name) {
    let downloadName = attachment.name
    // 可自动追加一个prefix前缀, 通常可以是条码号
    if (autoPrefix && !downloadName.includes(autoPrefix)) {
      downloadName = autoPrefix + '_' + downloadName
    }
    url = url + '&fileName=' + downloadName
  }
  return url
}

function getPublicResourceAttachmentLink (attachment, autoPrefix) {
  let url = prototype.$publicResourcesUrlDownload + attachment.ossUrl.replace(/\+/g, '%2B')
  if (attachment.name) {
    let downloadName = attachment.name
    // 可自动追加一个prefix前缀, 通常可以是条码号
    if (autoPrefix && !downloadName.includes(autoPrefix)) {
      downloadName = autoPrefix + '_' + downloadName
    }
    url = url + '&fileName=' + downloadName
  }
  return url
}
export default apiReturn()
